<template>
  <v-footer
    id="core-footer"
    absolute
    flex
    row
    height="82"
  >
    <v-layout
      row
      wrap>
      <v-flex xs12>
        <span style="text-align: center; font-size: 10px;">v{{ version }}</span><br/>
        <span style="font-size: 11px; font-weight: 500">
          &copy;
          {{ (new Date()).getFullYear() }}
          <a
            href="https://brcorte.com/"
            target="_blank">BR-Corte Soluções</a><br>
        </span>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    links: [
      { name: 'BR-Corte', Link: 'http://brcorte.com.br' }
    ]
  }),
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas']),
    version() {
      return this.$store.state.version;
    },
  }
}
</script>

<style>
#core-footer {
  z-index: 0;
  opacity: 0.5;
  text-align: center;
  color: #fff!important;
  background: transparent;
  font-size: 9px;
}
#core-footer a{
  text-decoration: none;
  color: #fff;
}
</style>
